"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMessageHooks = void 0;
const list_source_hook_1 = require("../../../../utils/list-source-hook");
exports.createMessageHooks = (webServicesUrl) => {
    const useMessageServices = () => {
        return list_source_hook_1.useListSource({
            url: `${webServicesUrl}/service/list`,
            method: 'GET',
        });
    };
    const useMessageOperations = () => {
        return list_source_hook_1.useListSource({
            url: `${webServicesUrl}/operation/list`,
            method: 'GET',
        });
    };
    return {
        useMessageServices,
        useMessageOperations,
    };
};
//# sourceMappingURL=messages-api.js.map